import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useBlockedDates() {
  const [blocked, setBlocked] = useState(() => new Set());

  useEffect(() => {
    let active = true;
    axios.get(`${API}/calendar/blocked-dates`)
      .then((r) => { if (active) setBlocked(new Set(r.data?.dates || [])); })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  return blocked;
}

export function isDateBlocked(d, blockedSet) {
  if (!d || !blockedSet) return false;
  const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  return blockedSet.has(iso);
}
